const isIE = !!window.navigator.userAgent.match(/MSIE|Trident/);

export function isValidBrowser() {
  return !isIE; 
}
